const faqs = [
  {
    q: '911爆料网是什么？',
    a: '911爆料网是一站式吃瓜黑料内容聚合平台，汇集全网最新的911吃瓜黑料事件、合集与视频。我们通过智能聚合和人工精选，为吃瓜群众提供最全面、最及时的爆料内容，是全网最大的吃瓜黑料网站入口之一。',
  },
  {
    q: '911爆料网的内容多久更新一次？',
    a: '我们的编辑团队7×24小时实时追踪全网热点，确保911吃瓜黑料最新内容在第一时间得到整理和发布。一般来说，重大爆料事件发生后30分钟内即可在平台上看到相关报道。',
  },
  {
    q: '如何向911爆料网提供爆料线索？',
    a: '你可以通过我们的官方邮箱 tips@911baoliao.com 或微信公众号"911爆料网"提交爆料线索。我们郑重承诺严格保护爆料人隐私，绝不会泄露任何个人信息。所有爆料经审核后将以匿名方式发布。',
  },
  {
    q: '911爆料网的内容来源是否可靠？',
    a: '我们建立了严格的多重审核机制。所有内容均来自公开网络信息整合，并由专业编辑团队进行事实核查。对于未经证实的信息，我们会标注"待核实"标签。作为负责任的911吃瓜黑料网站，我们始终坚持真实客观的内容原则。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见<span className="text-primary-500">问答</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              关于911爆料网，你想知道的都在这里
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <details
                key={idx}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer"
                open={idx === 0}
              >
                <summary className="flex items-center justify-between px-5 md:px-6 py-4 list-none">
                  <h3 className="text-sm md:text-base font-bold text-foreground-950 pr-4">
                    {faq.q}
                  </h3>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-600 group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                    <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}